<template>
  <Modal
    title="拆分"
    v-model="visible"
    width="340"
    @on-cancel="onClose"
    class-name="confirmTip-modal"
  >
    <div style="text-align: center">
      拆分
      <panguInputNumber isNewStyle :min="1" v-model="number"></panguInputNumber>
      行
    </div>
    <template #footer>
      <Button size="large" type="primary" class="sure-btn" @click="onClose">取消</Button>
      <Button size="large" type="primary" class="sure-btn" @click="onSure">确认</Button>
    </template>
  </Modal>
</template>
<script setup>
import { ref, nextTick } from 'vue'

const emit = defineEmits(['on-ok', 'on-cancel'])

const visible = ref(true)
const onClose = () => {
  visible.value = false
  nextTick(() => {
    emit('on-cancel')
  })
}

const number = ref(1)
const onSure = () => {
  visible.value = false
  nextTick(() => {
    emit('on-ok', number.value)
  })
}
</script>

<style lang="less">
.modal-input-number-content {
  display: flex;
  justify-content: center;
}
</style>
